import { useState } from 'react'
import CommunityMessagesChatPage from './CommunityMessagesChatPage'
import CommunityMessagesNewMessageGroupPage from './CommunityMessagesNewMessageGroupPage'
import { useCommunityFeature } from '../../services/useCommunityFeature'

export type CommunityMessagesPageMode = 'chat' | 'new_messages'

function CommunityMessagesPage({}: {}) {
    const communityFeature = useCommunityFeature()

    const [pageMode, set_pageMode] = useState<CommunityMessagesPageMode>('chat')

    if (pageMode === 'chat') {
        return <CommunityMessagesChatPage communityFeature={communityFeature} setPage={set_pageMode} />
    } else {
        return <CommunityMessagesNewMessageGroupPage communityFeature={communityFeature} setPage={set_pageMode} />
    }
}

export default CommunityMessagesPage
